import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { GraduationCap, Briefcase, Building2, BookOpen, Check } from 'lucide-react';

const profileTypes = [
  { value: 'student', label: 'Estudante', icon: GraduationCap, description: 'Estudando BIM ou área relacionada' },
  { value: 'professional', label: 'Profissional', icon: Briefcase, description: 'Trabalho com BIM' },
  { value: 'company', label: 'Empresa', icon: Building2, description: 'Empresa que usa ou oferece BIM' },
  { value: 'institution', label: 'Instituição', icon: BookOpen, description: 'Instituição de ensino ou pesquisa' }
];

export const Step1ProfileType = ({ formData, setFormData }) => (
  <div className="space-y-6">
    <div className="text-center mb-8">
      <h2 className="text-2xl font-bold text-white mb-2">Escolha o tipo de perfil</h2>
      <p className="text-gray-400">Como você quer ser identificado na comunidade BIM?</p>
    </div>

    <div className="grid md:grid-cols-2 gap-4">
      {profileTypes.map((type) => (
        <Card
          key={type.value}
          className={`cursor-pointer transition-all ${
            formData.profile_type === type.value
              ? 'bg-blue-600/20 border-blue-500'
              : 'bg-zinc-800 border-zinc-700 hover:border-zinc-600'
          }`}
          onClick={() => setFormData(prev => ({ ...prev, profile_type: type.value }))}
          data-testid={`profile-type-${type.value}`}
        >
          <CardContent className="p-6 flex items-start gap-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
              formData.profile_type === type.value ? 'bg-blue-600' : 'bg-zinc-700'
            }`}>
              <type.icon className="w-6 h-6 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-white">{type.label}</h3>
              <p className="text-sm text-gray-400">{type.description}</p>
            </div>
            {formData.profile_type === type.value && (
              <Check className="w-6 h-6 text-blue-500" />
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);

export default Step1ProfileType;
